import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { replaceValueInEvent } from "@dnhb/node_package";

export const RadioContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`;

const iconSize = 20;

const Label = styled.label`
  flex: 50% 0 0;
  max-width: calc(50% - 8px);

  input {
    opacity: 0;
    position: absolute;

    &:checked + span {
      border: 1px solid ${props => props.theme.primaryColor};
      color: ${props => props.theme.primaryColor};
      font-weight: 700;
      box-shadow: none;

      > .radio-circle {
        border-color: ${props => props.theme.primaryColor};

        &::before {
          background-color: ${props => props.theme.primaryColor};
        }
      }
      
      div svg {
         fill: ${props => props.theme.primaryColor};
      }
    }
    &:focus + span {
      box-shadow: 0 0 4px ${props => props.theme.primaryColor};
    }
  }

  span {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 40px;
    padding: 0 32px 0 40px;
    box-sizing: border-box;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.12);
    background-color: ${({ theme }) => theme.cardColor};
    cursor: pointer;
    font-size: 14px;
    color: ${props => props.theme.primaryFontColor};
    font-family: ${props => props.theme.fontFamily};
    font-weight: 600;
    text-align: center;
    margin: 8px 0;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      height: 40px;
    }
    
    div:not(.radio-circle) {
        height: ${iconSize}px;
        svg {
          display: block;
          height: ${iconSize}px;
          width: ${iconSize}px;
          fill: ${props => props.theme.secondaryColor};
          margin-right: 10px;
        }
    }

    > .radio-circle {
      position: absolute;
      left: 16px;
      top: 50%;
      box-sizing: border-box;
      padding: 2px;
      height: 16px;
      width: 16px;
      border-radius: 50%;
      border: 1px solid ${props => props.theme.disabledBackgroundColor};
      transform: translateY(-50%);

      &::before {
        content: '';
        display: block;
        height: 100%;
        width: 100%;
        border-radius: 50%;
      }
    }
    &:hover, &:focus {
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.24);
    }
  }
`;

const RadioButton = ({ name, value, children, onChange,  ...props }) => {
  const id = name + '-' + value;
  return (
    <Label htmlFor={id}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={e => {
          let newValue = e.target.value;
          if (newValue === 'true') newValue = true;
          if (newValue === 'false') newValue = false;
          const newValueIsNumber = !isNaN(Number(newValue));
          if (typeof newValue !== 'boolean' && newValueIsNumber) newValue = Number(newValue);
          onChange(replaceValueInEvent(e, newValue));
        }}
        {...props}
      />
      <span>
        <div className="radio-circle" />
        {children}
      </span>
    </Label>
  );
};

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]).isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  errors: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.bool]),
};

RadioButton.defaultProps = {
  readOnly: false,
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
  errors: null,
};

export default RadioButton;
